/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MembershipStatusFromJSON, MembershipStatusToJSON, } from './MembershipStatus';
import { MembershipHistoryItemFromJSON, MembershipHistoryItemToJSON, } from './MembershipHistoryItem';
/**
 * Check if a given object implements the MembershipInfo interface.
 */
export function instanceOfMembershipInfo(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('currentSeason' in value) || value['currentSeason'] === undefined)
        return false;
    if (!('history' in value) || value['history'] === undefined)
        return false;
    return true;
}
export function MembershipInfoFromJSON(json) {
    return MembershipInfoFromJSONTyped(json, false);
}
export function MembershipInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': MembershipStatusFromJSON(json['status']),
        'currentSeason': json['current_season'],
        'activeSeason': json['active_season'] == null ? undefined : json['active_season'],
        'history': (json['history'].map(MembershipHistoryItemFromJSON)),
    };
}
export function MembershipInfoToJSON(json) {
    return MembershipInfoToJSONTyped(json, false);
}
export function MembershipInfoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': MembershipStatusToJSON(value['status']),
        'current_season': value['currentSeason'],
        'active_season': value['activeSeason'],
        'history': (value['history'].map(MembershipHistoryItemToJSON)),
    };
}
